export default "__VITE_ASSET__CPN2MpbH__"